import React from 'react';
import { ShieldCheckIcon, CheckIcon } from 'lucide-react';
const terms = ['Get a full refund instantly', 'No questions asked', 'No hidden terms or conditions', 'Keep all the bonuses as our gift'];
export function Guarantee() {
  return <section id="guarantee" aria-labelledby="guarantee-heading" className="border-y border-celeste-500/25 bg-navy-900" data-id="element-71" data-mp="222whs3h73sli">
      <div className="mx-auto flex max-w-content flex-col gap-10 px-4 py-16 sm:px-6 lg:flex-row lg:gap-16 lg:py-20" style={{
      paddingTop: "0px",
      paddingBottom: "0px"
    }} data-id="element-72" data-mp="1x28r5iwvpdrt">
        <div className="flex h-24 w-24 shrink-0 items-center justify-center rounded-2xl border border-celeste-500/40 bg-navy-800" data-id="element-73" data-mp="14gz2sg20y5eb">
          <ShieldCheckIcon className="h-12 w-12 text-celeste-400" aria-hidden="true" data-id="element-74" data-mp="1j6n3pg6an21i" />
        </div>
        <div className="max-w-2xl" data-id="element-75" data-mp="1ec0tvhfv1hjj">
          <h2 id="guarantee-heading" className="font-display text-2xl font-extrabold uppercase leading-tight tracking-tight text-white sm:text-[2rem]" data-id="element-76" data-mp="qnq2d4w20u7x">
            7-Day 100% Money-Back Guarantee
          </h2>
          <p className="mt-4 text-white/75" data-id="element-77" data-mp="oygm6gi8jgbc">
            We&rsquo;re completely confident that The Argentine Mindset will transform how
            you think about challenges, money, and success. If for any reason you&rsquo;re
            not satisfied within 7 days:
          </p>
          <ul className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-78" data-mp="12rg0wga716hu">
            {terms.map(term => <li key={term} className="flex items-start gap-3 text-[15px] text-white/90" data-id="element-79" data-mp="60nj9e7m36dy">
                <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-celeste-400" aria-hidden="true" data-id="element-80" data-mp="630bck732x4q" />
                {term}
              </li>)}
          </ul>
          <p className="mt-6 text-white/70" data-id="element-81" data-mp="f0kdrwgomzgx">
            We&rsquo;ve tested this system with thousands of students. We know it works. And
            we&rsquo;re willing to back that up with our money.
          </p>
          <p className="mt-4 font-display text-lg font-bold text-white" data-id="element-82" data-mp="1qfzcb4ojhze5">
            Your success is our success. Period.
          </p>
        </div>
      </div>
    </section>;
}